import { useParams } from 'react-router-dom';
import { SettingsMaterialDefinitionsFormContainer } from 'modules/settings/pods/settings-materials/settings-material-definitions-form';

export const SettingsMaterialDefinitionsFormScene = () => {
    const { materialDefinitionId } = useParams<{ materialDefinitionId: string }>();
    return <SettingsMaterialDefinitionsFormContainer key={materialDefinitionId} />;
};

export default SettingsMaterialDefinitionsFormScene;
